import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { CompanyDepth } from "src/app/models/company-depth";
import { ApiService } from "src/app/services/api.service";
import { SignalRService } from "src/app/services/signalr.service";

@Component({
  selector: "app-quota-bids-asks",
  templateUrl: "./quota-bids-asks.component.html",
  styleUrls: ["./quota-bids-asks.component.scss"],
})
export class QuotaBidsAsksComponent implements OnInit {
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;

  isDepthLoading: boolean = false;
  companyDepth: CompanyDepth;
  isOrder: boolean = false;

  constructor(private _service: ApiService, signalService: SignalRService) {
    signalService.depthChanges.subscribe((res: any) => {
      res.forEach((element) => {
        if (element.SymbolCode == this.symbolCode) {
          if (this.isOrder) this.fetchDepthByOrder();
          else if (!this.isOrder) this.fetchDepthByPrice();
        }
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.symbolCode = changes.symbolCode.currentValue;
    if (this.symbolCode) {
      this.isDepthLoading = true;
      if (this.isOrder) this.fetchDepthByOrder();
      else if (!this.isOrder) this.fetchDepthByPrice();
    }
  }

  isOrderView(value) {
    this.isOrder = value;
  }
  fetchDepthByOrder() {
    this._service.fetchDepthByOrder(this.symbolCode).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepth;
    });
  }
  fetchDepthByPrice() {
    this._service.fetchDepthByPrice(this.symbolCode, 10).subscribe((res) => {
      this.isDepthLoading = false;
      this.companyDepth = res as CompanyDepth;
    });
  }
  ngOnInit() {}
}
